<template>
  <div class="row mt-2">
    <div class="col-md-12" style="color: #959595">
      <span>Below Zone:</span>
      <span style="margin-left: 10px"
        >{{ belowZoneTime }} / {{ belowZoneMinutes }}</span
      >
      <span class="ms-2">minutes</span>
    </div>
    <div class="col-md-12 mt-2" style="color: #224c7e">
      <span>In Zone:</span>
      <span style="margin-left: 10px"
        >{{ inZoneTime }} / {{ inZoneMinutes }}</span
      >
      <span class="ms-2">minutes</span>
    </div>
    <div class="col-md-12 mt-2" style="color: #e48126">
      <span>Above Zone:</span>
      <span style="margin-left: 10px"
        >{{ aboveZoneTime }} / {{ aboveZoneMinutes }}</span
      >
      <span class="ms-2">minutes</span>
    </div>
    <div class="col-md-12 mt-2">
      <span>In/Above Zone:</span>
      <span style="margin-left: 10px"
        >{{ inAboveZoneTime }} / {{ totalMinutes }}</span
      >
      <span class="ms-2">minutes</span>
    </div>
    <div class="col-md-12 mt-2">
      <training-progress :progress="percent" />
    </div>
    <div class="col-md-12 mt-2">
      <span>Training Progress:</span>
      <span class="ms-2">{{ goalStatus }}</span>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import TrainingProgress from '../../elements/training-progress'
export default {
  name: 'progress-zone-daily',
  components: {
    TrainingProgress,
  },
  computed: {
    ...mapGetters('usercardio', ['memberGoals']),
    belowZoneTime() {
      let _data = null
      if (this.memberGoals) {
        if (this.memberGoals.weekProgress) {
          if (this.memberGoals.weekProgress.length > 0) {
            _data = parseFloat(
              this.memberGoals.weekProgress[0].BelowZoneTime / 60
            ).toFixed(0)
          }
        }
      }
      return _data
    },
    inZoneTime() {
      let _data = null
      if (this.memberGoals) {
        if (this.memberGoals.weekProgress) {
          if (this.memberGoals.weekProgress.length > 0) {
            _data = parseFloat(
              this.memberGoals.weekProgress[0].InZoneTime / 60
            ).toFixed(0)
          }
        }
      }
      return _data
    },
    aboveZoneTime() {
      let _data = null
      if (this.memberGoals) {
        if (this.memberGoals.weekProgress) {
          if (this.memberGoals.weekProgress.length > 0) {
            _data = parseFloat(
              this.memberGoals.weekProgress[0].AboveZoneTime / 60
            ).toFixed(0)
          }
        }
      }
      return _data
    },
    belowZoneMinutes() {
      let _data = null
      if (this.memberGoals) {
        if (this.memberGoals.cardioProgram) {
          if (this.memberGoals.weekProgress.length > 0) {
            _data = parseFloat(
              this.memberGoals.cardioProgram[0].MinutesBelowZone
            ).toFixed(0)
          }
        }
      }
      return _data
    },
    inZoneMinutes() {
      let _data = null
      if (this.memberGoals) {
        if (this.memberGoals.cardioProgram) {
          if (this.memberGoals.weekProgress.length > 0) {
            _data = parseFloat(
              this.memberGoals.cardioProgram[0].MinutesInZone
            ).toFixed(0)
          }
        }
      }
      return _data
    },
    aboveZoneMinutes() {
      let _data = null
      if (this.memberGoals) {
        if (this.memberGoals.cardioProgram) {
          if (this.memberGoals.weekProgress.length > 0) {
            _data = parseFloat(
              this.memberGoals.cardioProgram[0].MinutesAboveZone
            ).toFixed(0)
          }
        }
      }
      return _data
    },
    inAboveZoneTime() {
      let _data = 0
      if (this.memberGoals) {
        if (this.memberGoals.weekProgress) {
          if (this.memberGoals.weekProgress.length > 0) {
            _data = (
              parseFloat(this.memberGoals.weekProgress[0].InZoneTime) / 60 +
              parseFloat(this.memberGoals.weekProgress[0].AboveZoneTime) / 60
            ).toFixed(0)
          }
        }
      }
      return _data
    },
    totalMinutes() {
      let _data = null
      if (this.memberGoals) {
        if (this.memberGoals.cardioProgram) {
          if (this.memberGoals.weekProgress.length > 0) {
            _data = parseFloat(
              this.memberGoals.cardioProgram[0].TotalMinutes
            ).toFixed(0)
          }
        }
      }
      return _data
    },
    percent() {
      let _data = 0
      if (this.memberGoals) {
        if (this.memberGoals.weekProgress) {
          if (this.memberGoals.weekProgress.length > 0) {
            _data = parseFloat(this.memberGoals.weekProgress[0].Percent)
          }
        }
      }
      return _data
    },
    goalStatus() {
      let _data = ''
      if (this.memberGoals) {
        if (this.memberGoals.weekProgress) {
          if (this.memberGoals.weekProgress.length > 0) {
            let percent = parseFloat(this.memberGoals.weekProgress[0].Percent)
            if (percent < 30) {
              _data = 'needs attention'
            } else if (percent >= 30 && percent < 75) {
              _data = 'goal met'
            } else {
              _data = 'exceeds goal'
            }
          }
        }
      }
      return _data
    },
  },
}
</script>
<style scoped>
</style>
